// Module
var code = "<div id=\"alertModal\"> <div class=\"modal-body\" ng-bind-html=\"msg\"></div> <div class=\"modal-footer\"> <button type=\"button\" ng-class=\"['btn btn-default',btnClass]\" ng-click=\"close()\">{{ btnLabel && (btnLabel | translate) || 'Ok' }} </button> </div> </div> ";
// Exports
export default code;